<template>
    <div class="DashboardScenarioNotification --global-clickable" @click="gotoScenario()">
        <div class="text">
            {{ $t('text') }}
            <span class="courseName">{{ $t(`dashboard.general.lifeskillLabels.${course.lifeskillNumber}`) }}</span>
            <!-- COMBAK how can I providee courseName when scenario can be part of multiple courses? -->
        </div>
        <div v-if="image" class="image" />
        <div v-if="time" class="time">
            {{ time }}
        </div>
    </div>
</template>

<translations>
  text: 'Here''s your daily habit training with a new scenario in'
  text_no: 'Her er din daglige vanetrening med et nytt scenario i'
</translations>

<script>
export default {
    props: {
        image: String,
        time: String,
        stepId: String,
        scenarioIndex: Number // COMBAK probably scenarioId
    },
    computed: {
        course() {
            return this.$store.state.moduleCourse.courses[this.step.courseId];
        },
        step() {
            return this.$store.state.moduleCourse.steps[this.stepId];
        }
    },
    methods: {
        gotoScenario() {
            this.$emit('action');
            this.$router.push({
                name: 'DashboardScenarioView',
                params: {
                    lifeskillId: this.course.lifeskillNumber,
                    stepId: this.stepId,
                    scenarioIndex: this.scenarioIndex
                } // COMBAK need scenarioId, verify that it works
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.DashboardScenarioNotification {
    padding: 1em;
    color: rgba(black, 0.5);
}
.image {
    width: 5em;
    height: 4em;
    background-color: gray;
    margin-top: 0.5em;
}
.text {
    line-height: 1.5em;
}
.time {
    color: rgba(black, 0.5);
    margin-top: 0.5em;
}
.courseName {
    color: rgba(black, 0.8);
}
</style>
